import type { Task } from '@awork/features/task/models/task.model'
import type { SortingDirection } from '@awork/_shared/models/sort-by-option.model'

export function groupByUser(tasks: Task[]): Record<string, Task[]> {
  return tasks.reduce((groups: Record<string, Task[]>, task) => {
    if (!task.hasAssignees) {
      groups.unassigned ? groups.unassigned.push(task) : (groups.unassigned = [task])

      return groups
    }

    task.assignees.forEach(user => {
      const userGroup = groups[user.id]

      userGroup ? userGroup.push(task) : (groups[user.id] = [task])
    })

    return groups
  }, {})
}

export function sortByUser(userA, userB, orderFactor = 1): number {
  if (!userA.id || !userA.name) {
    return orderFactor
  }

  if (!userB.id || !userB.name) {
    return orderFactor * -1
  }

  return orderFactor * userA.name.toLowerCase().localeCompare(userB.name.toLowerCase())
}

export function getSortedTasksByUser(tasks: Task[], order: SortingDirection = 'asc'): Task[] {
  const orderFactor = order === 'asc' ? 1 : -1

  return tasks.sort((taskA, taskB) => orderFactor * sortTasksByUser(taskA, taskB))
}

function sortTasksByUser(taskA: Task, taskB: Task): number {
  if (!taskA?.assignees?.length) {
    return -1
  }

  if (!taskB?.assignees?.length) {
    return 1
  }

  if (taskA.assignees.length === taskB.assignees.length) {
    const assigneeAName = taskA.assignees[0].name || ''
    const assigneeBName = taskB.assignees[0].name || ''

    return assigneeAName.toLowerCase().localeCompare(assigneeBName.toLowerCase())
  }

  return taskA.assignees.length > taskB.assignees.length ? 1 : -1
}
